/**
 * Display formatters for the storefront. Kept dependency-free (Intl only) so they
 * work the same in card meta, the featured panel, and any future price summary.
 */

/** Format a nightly price in the property's own currency (USD, INR, GBP, …). */
export function formatPrice(amount: number, currency: string): string {
  try {
    return new Intl.NumberFormat(undefined, {
      style: 'currency',
      currency,
      maximumFractionDigits: 0,
    }).format(amount);
  } catch {
    // Unknown/invalid currency code — fall back to the raw code + amount.
    return `${currency} ${amount.toLocaleString()}`;
  }
}

/**
 * Turn a snake_case enum key into a display label, e.g. "air_conditioning" →
 * "Air conditioning", "wifi" → "Wifi". Shared so amenity checkboxes, active-filter
 * chips, and the hotel-detail amenity list all render identically (never a raw key).
 */
export function humanize(raw: string): string {
  const s = raw.replace(/_/g, ' ').trim();
  return s.charAt(0).toUpperCase() + s.slice(1);
}

/** Initials for an image fallback chip, e.g. "Coastal Haven Lodge" → "CH". */
export function initials(name: string): string {
  return name
    .split(/\s+/)
    .filter(Boolean)
    .slice(0, 2)
    .map((w) => w[0]?.toUpperCase() ?? '')
    .join('');
}
